export const fileToBase64 = (file: File) => {
  return new Promise((resolve) => {
    let reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      const base64 = extractBase64(reader.result);

      resolve(base64);
    };
  });
};

const extractBase64 = (dataUrl: any) => {
  let index = dataUrl.indexOf('base64');
  if (index === -1) {
    return null;
  }

  return dataUrl.substring(index + 7);
};
